
import { defineComponent, reactive, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StoreUtil from '@/stores/StoreUtil'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'

export default defineComponent({
  name: 'PasswordChangeSendMailCompletelyPage',
  setup() {
    const state = reactive({
      isEnabledResend: true,
      isVisibleConfirm: false,
      dialogSetting: {
        title: '',
        message: '',
      },
    })
    const passwordChangeStore = StoreUtil.useStore('PasswordChangeStore')
    const messageDialogStore = StoreUtil.useStore('MessageDialogStore')
    const { t, locale } = useI18n()
    onMounted(() => {
      useValidateForAccess('PasswordChangeStore', ['userId'], 'ErrorPage')
    })

    /**
     * 教育向け（KOKO）ビルドかどうか
     */
    const isKokoBuild = computed(() => {
      return process.env.VUE_APP_BUILD_TARGET === 'koko'
    })

    return {
      state,
      t,
      locale,
      isKokoBuild,
      /**
       * メール再送信ボタンを押下したときの処理
       */
      async onClickReSendMail() {
        state.isEnabledResend = false
        const submitResult = await passwordChangeStore.getTokenAndSendResetPasswordMail()
        let dialogOptions = {}
        if (submitResult.isSuccess) {
          dialogOptions = {
            title: t('PasswordChangeSendMailCompletelyPage.resendComplete.title'),
            message: t('PasswordChangeSendMailCompletelyPage.resendComplete.message'),
          }
        } else {
          switch (submitResult.res.response.data.error_code) {
            case '401_0001': {
              dialogOptions = {
                title: t('PasswordChangeSendMailCompletelyPage.authenticationError.title'),
                message: t(
                  `PasswordChangeSendMailCompletelyPage.authenticationError.${
                    isKokoBuild.value ? 'message_koko' : 'message'
                  }`,
                ),
                status: 'error',
              }
              break
            }
            case '500_0018': {
              dialogOptions = {
                title: t('PasswordChangeSendMailCompletelyPage.failedToSendMail.title'),
                message: t(
                  `PasswordChangeSendMailCompletelyPage.failedToSendMail.${
                    isKokoBuild.value ? 'message_koko' : 'message'
                  }`,
                ),
                status: 'error',
              }
              break
            }
            // TODO LINEの場合の考慮
            // case '500_0026': {
            //   dialogOptions = {
            //     title: t('PasswordChangeSendMailCompletelyPage.failedToSendLine.title'),
            //     message: t('PasswordChangeSendMailCompletelyPage.failedToSendLine.message'),
            //     status: 'error',
            //   }
            //   break
            // }
            case 'NETWORK_ERROR': {
              dialogOptions = {
                title: t('dialog.netWorkError.title'),
                message: t('dialog.netWorkError.message'),
                status: 'error',
              }
              break
            }
            default: {
              dialogOptions = {
                title: t('dialog.unknownError.title'),
                message: t('dialog.unknownError.message', [
                  submitResult.res.response.data.error_code,
                ]),
                status: 'error',
              }
              break
            }
          }
        }
        await messageDialogStore.openWithSettings(dialogOptions)
        state.isEnabledResend = true
      },
    }
  },
  components: {
    RegisterFlow,
  },
})
